export default "__VITE_ASSET__bfb300cf__"